export enum PurposeEnum {
  CORRECTION = "correction",
  LESSON = "lesson",
  MASTERCLASS = "masterclass",
  OTHER = "other",
}
